// extracted by mini-css-extract-plugin
module.exports =  {"tabs":"_93444fe79c--tabs--d1EN4","tabs--animated":"_93444fe79c--tabs--animated--IDnlt"};